import MyTransport from "../../js/pages/student/MyTransport";
import Main from "../../js/components/layout/Main";
import ProtectedRoute from "../components/comps/protected_route";
import MyReports from "../pages/student/MyReport";
import MyAttendance from "../pages/student/MyAttendance";
import LmsLearning from "../pages/student/LmsLearning";

const StudentRoutes = [
  {
    path: "/student",
    element: <Main />,
    children: [
      {
        path: "lms",
        element: (
          <ProtectedRoute allowUnlisted>
            <LmsLearning />
          </ProtectedRoute>
        ),
      },
      {
        path: "my_transport",
        element: (
          <ProtectedRoute>
            <MyTransport />
          </ProtectedRoute>
        ),
      },
      {
        path: "my_report",
        element: (
          <ProtectedRoute>
            <MyReports />
          </ProtectedRoute>
        ),
      },
      {
        path: "my_attendance",
        element: (
          <ProtectedRoute>
            <MyAttendance />
          </ProtectedRoute>
        ),
      },
    ],
  },
];

export default StudentRoutes;
